import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconZoomSvg } from "./IconZoomSvg.mjs";
const IconZoom = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconZoomSvg, ...iconProps });
};
export {
  IconZoom
};
